import React from "react";
import PropTypes from "prop-types";

const Attention = ({ classNames, color }) => (
  <svg
    className={classNames}
    width="40"
    height="36"
    viewBox="0 0 40 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39.3913 29.0228L31.6722 15.6476L23.9485 2.2769C23.5478 1.5845 22.972 1.00965 22.279 0.610008C21.5859 0.21037 20.8 0 20 0C19.2 0 18.414 0.21037 17.721 0.610008C17.028 1.00965 16.4522 1.5845 16.0515 2.2769L8.32784 15.6476L0.608649 29.0228C0.209445 29.7161 -0.000455876 30.5021 7.43411e-07 31.3021C0.000457363 32.102 0.211255 32.8878 0.611251 33.5806C1.01125 34.2734 1.58638 34.8488 2.27895 35.2492C2.97153 35.6495 3.75721 35.8607 4.55718 35.8616H35.4428C36.2428 35.8607 37.0285 35.6495 37.721 35.2492C38.4136 34.8488 38.9888 34.2734 39.3887 33.5806C39.7887 32.8878 39.9995 32.102 40 31.3021C40.0005 30.5021 39.7906 29.7161 39.3913 29.0228V29.0228ZM37.466 32.4689C37.2645 32.8272 36.9704 33.1248 36.6144 33.3305C36.2585 33.5362 35.8539 33.6425 35.4428 33.6383H4.55718C4.14747 33.6375 3.74517 33.529 3.39057 33.3238C3.03596 33.1186 2.74148 32.8238 2.53661 32.469C2.33174 32.1142 2.22367 31.7118 2.22321 31.3021C2.22275 30.8924 2.32992 30.4897 2.534 30.1345L10.2532 16.7593L17.9768 3.38854C18.1824 3.03409 18.4775 2.73987 18.8326 2.53534C19.1877 2.33082 19.5902 2.22317 20 2.22317C20.4098 2.22317 20.8123 2.33082 21.1674 2.53534C21.5225 2.73987 21.8176 3.03409 22.0232 3.38854L29.7468 16.7593L37.466 30.1345C37.6749 30.488 37.7851 30.8911 37.7851 31.3017C37.7851 31.7123 37.6749 32.1154 37.466 32.4689Z"
      fill={color}
    />
    <path
      d="M21.6162 24.0303H18.1006L17.6025 9.25H22.1143L21.6162 24.0303ZM19.8584 26.3447C20.5713 26.3447 21.1426 26.5547 21.5723 26.9746C22.0117 27.3945 22.2314 27.9316 22.2314 28.5859C22.2314 29.2305 22.0117 29.7627 21.5723 30.1826C21.1426 30.6025 20.5713 30.8125 19.8584 30.8125C19.1553 30.8125 18.584 30.6025 18.1445 30.1826C17.7148 29.7627 17.5 29.2305 17.5 28.5859C17.5 27.9414 17.7148 27.4092 18.1445 26.9893C18.584 26.5596 19.1553 26.3447 19.8584 26.3447Z"
      fill={color}
    />
  </svg>
);

Attention.defaultProps = {
  color: "red",
  classNames: "",
};

Attention.propTypes = {
  color: PropTypes.string,
  classNames: PropTypes.string,
};

export default Attention;
